import React, { useEffect, useState } from "react";
import { Tabs, Tab, TabPanel, TabList } from "react-tabs";
import CancelledProjectOrderTable from "./tables/CancelledProjectOrderTable";
import CompletedProjectOrderTable from "./tables/CompletedProjectOrderTable";
import OngoingProjectOrderTable from "./tables/OngoingProjectOrderTable";
import { isAuth } from "../../auth/ProtectedRoute";
import axios from "axios";

const MarketplaceOrderManagementTab = () => {
  const [ongoingTotal, setOngoingTotal] = useState<number>(0);
  const [completedTotal, setCompletedTotal] = useState<number>(0);
  const [cancelledTotal, setCancelledTotal] = useState<number>(0);
  const getOngoingTotal = (newValue: number) => {
    setOngoingTotal(newValue);
  };

  useEffect(() => {
    axios({
      method: "GET",
      url:
        process.env.REACT_APP_HOST_API +
        `order-management/list?status=completed`, //change status to ongoing to see data, completed order data is currently empty
      headers: {
        Authorization: `Bearer ${isAuth()}`,
      },
    })
      .then((res) => {
        if (res.data.response === true && res.data.status === 200) {
          setCompletedTotal(res?.data?.data?.length);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    axios({
      method: "GET",
      url:
        process.env.REACT_APP_HOST_API +
        `order-management/list?status=cancelled`, //change status to ongoing to see data, cancelled order data is currently empty
      headers: {
        Authorization: `Bearer ${isAuth()}`,
      },
    })
      .then((res) => {
        if (res.data.response === true && res.data.status === 200) {
          setCancelledTotal(res?.data?.data?.length);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return (
    <div className="task-dashboard">
      <div className="project-table" style={{ 
        display: "flex", 
        flexDirection: "column",
      }}>
        <Tabs style={{ flex: 1 }}>
          <TabList
            style={{
              borderBottom: "none",
              margin: 0,
              display: "flex",
              alignItems: "center"
            }}
          >
            <Tab className="project-tab">
              <span className="tab-label">Ongoing</span>
              <span className="tab-count">{ongoingTotal}</span>
            </Tab>
            <div style={{ height: "20px", width: "1px", background: "#E8E8E8", margin: "0 25px" }}></div>
            <Tab className="project-tab">
              <span className="tab-label">Completed</span>
              <span className="tab-count">{completedTotal}</span>
            </Tab>
            <div style={{ height: "20px", width: "1px", background: "#E8E8E8", margin: "0 25px" }}></div>
            <Tab className="project-tab">
              <span className="tab-label">Cancelled</span>
              <span className="tab-count">{cancelledTotal}</span>
            </Tab>
          </TabList>
          <TabPanel className="pending-button">
            <OngoingProjectOrderTable getOngoingTotal={getOngoingTotal} />
          </TabPanel>
          <TabPanel className="approval-button">
            <CompletedProjectOrderTable />
          </TabPanel>
          <TabPanel className="approval-button">
            <CancelledProjectOrderTable />
          </TabPanel>
          <TabPanel className="approval-button">
            {/* <MediationProjectOrderTable /> */}
          </TabPanel>
        </Tabs>
      </div>
    </div>
  );
};
export default MarketplaceOrderManagementTab;
